import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FriedH5 = _resolveComponent("FriedH5");
    const _component_FriedParagraph = _resolveComponent("FriedParagraph");
    const _component_EditorNodeEmptyState = _resolveComponent("EditorNodeEmptyState");
    return (_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_EditorNodeEmptyState, {
            icon: _ctx.elementIcon,
            heading: _ctx.heading
        }, _createSlots({ _: 2 }, [
            (_ctx.node.content)
                ? {
                    name: "action",
                    fn: _withCtx(() => [
                        _createElementVNode("div", null, [
                            _createVNode(_component_FriedH5, null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.t('content_element_placeholder_description_room_context')), 1)
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_FriedParagraph, { class: "element-placeholder-note" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.node.content), 1)
                                ]),
                                _: 1
                            })
                        ])
                    ]),
                    key: "0"
                }
                : undefined
        ]), 1032, ["icon", "heading"])
    ]));
}
